export interface AreaOfInterestOption {
  value: string
  label: string
}

export const areaOfInterestOptions: Array<AreaOfInterestOption> = [
  {
    value: `agricultureandenvironmentalsustainability`,
    label: `Agriculture and Environmental Sustainability`,
  },
  { value: `artdesigndigitalmedia`, label: `Art, Design and Digital Media` },
  { value: `businessandmanagement`, label: `Business and Management` },
  { value: `coned`, label: `Continuing Education` },
  {
    value: `educationhumanandsocialservices`,
    label: `Education, Human and Social Services`,
  },
  { value: `engineering`, label: `Engineering` },
  { value: `healthandwellness`, label: `Health and Wellness` },
  {
    value: `hospitalitytourismandculinary`,
    label: `Hospitality, Tourism and Culinary`,
  },
  { value: `indigenousstudies`, label: `Indigenous Studies` },
  { value: `marine`, label: `Marine` },
  {
    value: `publicsafetyandemergencyservices`,
    label: `Public Safety and Emergency Services`,
  },
  { value: `skilledtrades`, label: `Skilled Trades` },
  { value: `sportsandrecreation`, label: `Sports and Recreation` },
  { value: `technologyandit`, label: `Technology and IT` },
]

export const normalizeAreaOfInterestValues = (
  value: unknown
): Array<string> => {
  const values = Array.isArray(value) ? value : [value]

  return values.flatMap(item =>
    typeof item === `string`
      ? item
        .split(`;`)
        .map(area => area.trim().toLowerCase())
        .filter(Boolean)
      : []
  )
}
